/* eslint-disable */
// 对应 lily.core.js 封装了一些全局通用API 另外会读取sessionstorage，将ukey和验签的配置也在这里挂载到$.lily上
import getMethods from './methods'
import store from '@/store'
const APP_BASE_CONFIG = store.state.app.appInfo

export default {
  install: function (Vue, options) {
    const methods = getMethods.call(Vue.prototype)
    Vue.prototype.$_core = {
      ...methods,
      version: "@VERSION",
      // 此次登录态下的信息
      sessionData: {},
      /**
       * 是否启用密码控件，必须与settings.xml文件的一致
       */
      keyCodeControlEnabled: APP_BASE_CONFIG.APP_KEYCODE_CONTROL_ENABLED,
      /*证书相关*/
      /**
       * 是否启用签名验签，必须与settings.xml文件的一致
       */
      signDataEnabled: APP_BASE_CONFIG.APP_SIGNDATA_ENABLED,
      /**
       * 是否支持文件证书，生产环境应该为false
       */
      fileCertEnabled: false,
      /**
       * 是否支持移动证书，生产环境应该为true
       */
      mobileCertEnabled: false,
      /**
       * 是否使用虚拟报文
       */
      readLocalFile: false,
      /**
       * local file 存储文件夹
       */
      localFilePath: "virtualHost/",
      signDataCertOU: "C = CN",
      /**
       *渠道标志channel定义 ：个人会员中心 原01
       */
      PC_pb_tranCenter: "1101",
      /**
       *渠道标志channel定义 ：个人网上营业厅 原04
       */
      PC_pb_loginService: "1102",
      /**
       *渠道标志channel定义 ：企业会员中心 原02
       */
      PC_cb_tranCenter: "1103",
      /**
       *渠道标志channel定义 ：企业网上营业厅 原05
       */
      PC_cb_loginService: "1104",
      /**
       *渠道标志channel定义 ：快捷服务区 原06
       */
      PC_quickService: "1105",

      keyCode: {
        ALT: 18,
        BACKSPACE: 8,
        CAPS_LOCK: 20,
        COMMA: 188,
        COMMAND: 91,
        COMMAND_LEFT: 91, // COMMAND
        COMMAND_RIGHT: 93,
        CONTROL: 17,
        DELETE: 46,
        DOWN: 40,
        END: 35,
        ENTER: 13,
        ESCAPE: 27,
        HOME: 36,
        INSERT: 45,
        LEFT: 37,
        MENU: 93, // COMMAND_RIGHT
        NUMPAD_ADD: 107,
        NUMPAD_DECIMAL: 110,
        NUMPAD_DIVIDE: 111,
        NUMPAD_ENTER: 108,
        NUMPAD_MULTIPLY: 106,
        NUMPAD_SUBTRACT: 109,
        PAGE_DOWN: 34,
        PAGE_UP: 33,
        PERIOD: 190,
        RIGHT: 39,
        SHIFT: 16,
        SPACE: 32,
        TAB: 9,
        UP: 38,
        WINDOWS: 91 // COMMAND
      },

      CONFIG_SESSION_ID: '',
      sequenceMap: {},

      localization: {
        connectError: '通讯失败',
        loadingMsg: '加载中...',
        mainPage: '首页',
        closeAllPage: '关闭所有',
        noMessage: '没有通知信息',
        errorMsgRemind: '错误信息：',
        errorCodeRemind: '错误代码：'
      }
    }
  }
}
